var map = {
	"./004-united-states.svg": "256c",
	"./005-chile.svg": "8694",
	"./br.svg": "8d78",
	"./chile.svg": "f1ba",
	"./en.svg": "7534",
	"./es.svg": "b45f",
	"./it.svg": "b468",
	"./pt.svg": "a673",
	"./united-states.svg": "91ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6053";